export const name = 'templateThumbnailDirective';
export default function templateThumbnailDirective() {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var directive = {
        restrict: 'E',
        template: require('./template-thumbnail.html'),
        scope: {
            template: '=template',
            thumbnailWidth:'=thumbnailWidth',
            thumbnailHeight:'=thumbnailHeight',
            viewDetailsFunc:'=viewDetailsFunc'
        },

        controller: templateThumbnailController,
        controllerAs: 'vm',
        bindToController: true
    };

    return directive;
}

function templateThumbnailController($translate, $mdDialog, templatesService) {
//noinspection BadExpressionStatementJS
    'ngInject';
    /* jshint validthis: true */

    var vm = this;
    vm.onImageLoad = onImageLoad;
    vm.imageDimensionCalculated = false;
    vm.imageWidth = 0;
    vm.imageHeight = 0;
    vm.isSelected = false;
    vm.templatesService = templatesService;
    vm.getErrorIcon = getErrorIcon;
    vm.getWarningIcon = getWarningIcon;
    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    let errorIcon = iconsRequire("./error.svg");
    let warningIcon = iconsRequire("./warning.svg");

    initialize();

    function initialize(){
        if(vm.template.thubmnailsDimensions === undefined){
            vm.template.thubmnailsDimensions={
                imageDimensionCalculated: false
            };
        }
    }

    function onImageLoad(){
        let imageElement = angular.element(document.getElementById('thumb-' + vm.template.templateId));
        if(imageElement.length === 0 ||  imageElement[0].naturalWidth === 0 || imageElement[0].naturalHeight === 0){
            return;
        }else{
            if((imageElement[0].src && (vm.template.imageSrc === undefined || vm.template.imageSrc === null || vm.template.imageSrc === "")) //||
                ){//(imageElement[0].src && vm.template.imageSrc && (vm.template.imageSrc !== imageElement[0].src))
                vm.template.imageSrc = imageElement[0].src;
                calculateThumbnailDimensions(vm.template);
            }
        }
    }

    function calculateThumbnailDimensions(template){
        let imageElement = angular.element(document.getElementById('thumb-' + template.templateId));
        if(imageElement.length === 0 || imageElement[0].naturalWidth === 0 || imageElement[0].naturalHeight === 0){
            return;
        }

        let spaceForAboveMessage = 60; //space For Above = margin at bottom
        if(vm.template.templateCreationStatus === 'Warning'){
            spaceForAboveMessage = 100;
        }

        let maxThumbHeight = vm.thumbnailHeight - spaceForAboveMessage;
        let maxThumbWidth = vm.thumbnailWidth - 30; // -30 for left\right margin

        let maxWidthRatio = imageElement[0].naturalWidth / maxThumbWidth;
        let maxHeightRatio = imageElement[0].naturalHeight / maxThumbHeight;

        if(maxWidthRatio > maxHeightRatio && maxWidthRatio > 1){


            vm.template.thubmnailsDimensions.imageWidth = maxThumbWidth;
            //vm.imageHeight

            /*template.thumbDimention = {
                width:vm.thumbnailCardWidth, // in vw
                height: 'auto',
            };*/
        } else if (maxHeightRatio > maxWidthRatio && maxHeightRatio > 1){
            vm.template.thubmnailsDimensions.imageWidth = (1/maxHeightRatio) * imageElement[0].naturalWidth;
            /*template.thumbDimention = {
                width: (1/maxHeightRatio) * imageElement[0].naturalWidth,
                height: 'auto',
            };*/
        }else{
            vm.template.thubmnailsDimensions.imageWidth = maxThumbWidth;//imageElement[0].naturalWidth;
            /*template.thumbDimention = {
                width: imageElement[0].naturalWidth ,
                height: 'auto',
            };*/
        }



        vm.template.thubmnailsDimensions.imageDimensionCalculated = true;
    }

    function getErrorIcon(){
        return errorIcon;
    }

    function getWarningIcon(){
        return warningIcon;
    }
}
